export default {
  ui: {

  },
  validation: {
    // required({ name }) {
    //   return `${name} is verplicht. YOLO!`
    // },
  },
}
